import { LayoutDashboard, BookOpen, TrendingUp, Dumbbell } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ViewKey } from './BottomNav';

interface NavItem {
  key: ViewKey;
  label: string;
  Icon: LucideIcon;
}

const ITEMS: readonly NavItem[] = [
  { key: 'dashboard', label: 'Dashboard', Icon: LayoutDashboard },
  { key: 'library', label: 'Bibliothek', Icon: BookOpen },
  { key: 'progress', label: 'Fortschritt', Icon: TrendingUp },
] as const;

interface SideNavProps {
  active: ViewKey;
  onChange: (next: ViewKey) => void;
}

export function SideNav({ active, onChange }: SideNavProps): JSX.Element {
  return (
    <aside
      aria-label="Hauptnavigation"
      className="hidden md:flex md:w-56 md:shrink-0 md:flex-col md:gap-1 md:border-r md:border-zinc-200 md:bg-white md:px-3 md:py-6"
    >
      <div className="mb-6 flex items-center gap-2 px-2">
        <Dumbbell aria-hidden="true" className="size-6 text-emerald-600" />
        <span className="text-base font-semibold text-zinc-900">NeoOlymp</span>
      </div>
      <nav>
        <ul className="flex flex-col gap-1">
          {ITEMS.map(({ key, label, Icon }) => {
            const isActive = key === active;
            return (
              <li key={key}>
                <button
                  type="button"
                  onClick={() => onChange(key)}
                  aria-current={isActive ? 'page' : undefined}
                  className={`flex h-11 w-full items-center gap-3 rounded-lg px-3 text-sm transition-transform duration-[120ms] active:scale-[0.99] focus-visible:outline-2 focus-visible:outline-emerald-500 focus-visible:outline-offset-2 ${
                    isActive
                      ? 'bg-emerald-50 font-semibold text-emerald-700'
                      : 'font-medium text-zinc-700 hover:bg-zinc-50'
                  }`}
                >
                  <Icon
                    aria-hidden="true"
                    className={`size-5 ${isActive ? 'text-emerald-600' : 'text-zinc-500'}`}
                  />
                  {label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}
